import { render, staticRenderFns } from "./CollapsePanel.vue?vue&type=template&id=feb42c90&scoped=true&"
import script from "./CollapsePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsePanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsePanel.vue?vue&type=style&index=0&id=feb42c90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb42c90",
  null
  
)

export default component.exports